// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AuthController from "./auth_controller"
application.register("auth", AuthController)

import BottomSheetController from "./bottom_sheet_controller"
application.register("bottom-sheet", BottomSheetController)

import CarouselController from "./carousel_controller"
application.register("carousel", CarouselController)

import ChatInputController from "./chat_input_controller"
application.register("chat-input", ChatInputController)

import ChatScrollController from "./chat_scroll_controller"
application.register("chat-scroll", ChatScrollController)

import CompassController from "./compass_controller"
application.register("compass", CompassController)

import CountdownController from "./countdown_controller"
application.register("countdown", CountdownController)

import CustomVideoController from "./custom_video_controller"
application.register("custom-video", CustomVideoController)

import DistanceController from "./distance_controller"
application.register("distance", DistanceController)

import DrawerController from "./drawer_controller"
application.register("drawer", DrawerController)

import FcmController from "./fcm_controller"
application.register("fcm", FcmController)

import FlashController from "./flash_controller"
application.register("flash", FlashController)

import FullscreenController from "./fullscreen_controller"
application.register("fullscreen", FullscreenController)

import GeolocationController from "./geolocation_controller"
application.register("geolocation", GeolocationController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ImagePreviewController from "./image_preview_controller"
application.register("image-preview", ImagePreviewController)

import MultipleImagePreviewController from "./multiple_image_preview_controller"
application.register("multiple-image-preview", MultipleImagePreviewController)

import NativeSettingsController from "./native_settings_controller"
application.register("native-settings", NativeSettingsController)

import PhoneInputController from "./phone_input_controller"
application.register("phone-input", PhoneInputController)

import PlacesController from "./places_controller"
application.register("places", PlacesController)

import PollController from "./poll_controller"
application.register("poll", PollController)

import PresenceController from "./presence_controller"
application.register("presence", PresenceController)

import RazorpayController from "./razorpay_controller"
application.register("razorpay", RazorpayController)

import ReplyToggleController from "./reply_toggle_controller"
application.register("reply-toggle", ReplyToggleController)

import ResetFormController from "./reset_form_controller"
application.register("reset-form", ResetFormController)

import ShareController from "./share_controller"
application.register("share", ShareController)

import StoryTaggerController from "./story_tagger_controller"
application.register("story-tagger", StoryTaggerController)

import VideoPreviewController from "./video_preview_controller"
application.register("video-preview", VideoPreviewController)

import VideoSoundController from "./video_sound_controller"
application.register("video-sound", VideoSoundController)

import WebpushController from "./webpush_controller"
application.register("webpush", WebpushController)
